import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreProfilesModule } from '@freelancer/datastore/collections';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { UserProfileSummaryCreatingModalComponent } from './user-profile-summary-creating-modal.component';
import { UserProfileSummaryEditingFormComponent } from './user-profile-summary-editing-form.component';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    TrackingModule,
    UiModule,
    DatastoreProfilesModule,
  ],
  declarations: [
    UserProfileSummaryCreatingModalComponent,
    UserProfileSummaryEditingFormComponent,
  ],
})
export class UserProfileSummaryCreatingModalModule {}
